<div id="annotation-window" [ngClass]="{ 'scaled-up': this.zoom > 1 }">
  <div id="img-container">
    <img id="asset-img" [src]="fileUrl" alt="" (load)="imgLoaded($event)" />
  </div>
  <div id="konva-holder"></div>
</div>

<div class="media-asset-toolbar">
  <ul class="media-asset-toolbar-list media-asset-toolbar-area">
    <li class="media-asset-toolbar-item">
      <button mat-icon-button class="media-asset-toolbar-action" (click)="zoomImage(1)" [disabled]="zoom === maxZoom" i18n-matTooltip matTooltip="Zoom in">
        <mat-icon class="material-icons-outlined">zoom_in</mat-icon>
      </button>
    </li>

    <li class="media-asset-toolbar-item">
      <button mat-icon-button class="media-asset-toolbar-action" (click)="zoomImage(-1)" [disabled]="zoom === 1" i18n-matTooltip matTooltip="Zoom out">
        <mat-icon class="material-icons-outlined">zoom_out</mat-icon>
      </button>
    </li>

    <li class="media-asset-toolbar-item">
      <button mat-icon-button class="media-asset-toolbar-action" (click)="openAssetFullscreen()" i18n-matTooltip matTooltip="Expand asset">
        <mat-icon class="material-icons-outlined">open_in_full</mat-icon>
      </button>
    </li>
  </ul>
</div>
